"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var ConditionalDisplay_1 = __importDefault(require("../../Mixins/ConditionalDisplay"));
var PredicateInput_1 = __importDefault(require("../../Mixins/PredicateInput"));
var SourceValue_1 = __importDefault(require("../../Mixins/SourceValue"));
var FormulaInput_1 = __importDefault(require("../../Mixins/FormulaInput"));
var FormulaOutput_1 = __importDefault(require("../../Mixins/FormulaOutput"));
exports.default = vue_1.default.extend({
    mixins: [ConditionalDisplay_1.default, PredicateInput_1.default, SourceValue_1.default, FormulaInput_1.default, FormulaOutput_1.default],
    props: ['name', 'label', 'cssClass', 'placeholder', 'inputGroupText', 'required', 'readonly'],
    methods: {
        getReadonly: function () {
            return (this.$root.$data.readOnly || this.readonly);
        },
        setFormulaResult: function (result) {
            this.value = result;
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./_wwwsrc/js/Workflow/Components/Input/Number.vue
// module id = 185
// module chunks = 0